import React from 'react';
import "../style/AppPages.css"
import { Trans, useTranslation } from 'react-i18next';

const ContactUs = () => {
    const { t } = useTranslation();

    return (
        <div class="page-padding-info">
            <div class="text-page-container">
                <h1 class="text-page-title">{t("contactUs.contactUsTitle")}</h1>

                <p>
                    &nbsp;
                    <strong>
                        <Trans i18nKey="contactUs.contactUsText" components={{ 1: <a href="mailto:contact@awootoys.com" /> }} />
                    </strong>
                </p>
                
            </div>
        </div>
    );
}

export default ContactUs;